import { EnvironmentHeritageLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "a08c2b36-b5f2-4348-86a8-f09c43d4658a",
    label: "1 & 1A, Cathedral Road, Ward No.-63",
  },
  {
    fileStoreId: "8f4b0e1c-271a-4846-a401-3376babbceec",
    label: "1, Clive Buildings, Ward No.-45 (1)",
  },
  {
    fileStoreId: "22fb784f-39e1-4d03-8f0d-4298b0c802e3",
    label: "1,Hogg Street, CVF Block",
  },
  {
    fileStoreId: "a87a028a-9259-410d-bca6-eb8c93d7f170",
    label: "1,R N Mukherjee Road, Ward No.-46",
  },
  {
    fileStoreId: "929e95ee-e5dd-48a4-81e0-bbfad3a5e0ae",
    label: "1,R N Mukherjee Road, Ward No.-46",
  },
  {
    fileStoreId: "cdb58aca-ed48-4bd3-a72f-da2ba6a0a734",
    label: "2, Camac Street, Ward No.-63",
  },
  {
    fileStoreId: "bbbd62f3-32b3-4700-88ff-c2d5f75fa219",
    label: "3, Lovelock Place, Ward No.-69",
  },
  {
    fileStoreId: "f151868f-9a40-4a3d-a387-944676647c58",
    label: "4, Bepin Pal Road, Ward No.-84",
  },
  {
    fileStoreId: "52af12e0-673d-46c4-8f76-c10936344831",
    label: "5, Jawaharlal Nehru Road, Ward No.-63",
  },
  {
    fileStoreId: "49a494c4-faee-4171-912a-bedc07f774b7",
    label: "6, Lyons Range, Ward No.-45",
  },
  {
    fileStoreId: "28ec8c96-d748-4bbf-a80c-b556c5d3104e",
    label: "6, Lyons Range, Ward No.-45_29.09.20",
  },
  {
    fileStoreId: "b7cfae6a-a48c-4cc1-bb1d-5f09cd1b2de0",
    label: "7,William Jones Sarani, Ward No.-63_29.09.20",
  },
  {
    fileStoreId: "413de231-4472-4327-ab82-fd104931335c",
    label: "8E, James Hickey Sarani, Ward No.-46",
  },
  {
    fileStoreId: "b8c17cc0-405f-4a7b-b7f3-6461dae3ad37",
    label: "12, Binode Saha Lane, Ward No.-27",
  },
  {
    fileStoreId: "eb60e824-95aa-4a5f-ac8b-cdd557ffdf7a",
    label: "12A, Netaji Subhas Road, Ward No.-45",
  },
  {
    fileStoreId: "c80c7a28-5120-4d3b-8a4d-058abaa9fca4",
    label: "13, Bankim Chatterjee Street, Ward No.-40",
  },
  {
    fileStoreId: "2374640b-4d7a-4eda-a559-87c409595443",
    label: "13, Wood Street, Ward No.-63",
  },
  {
    fileStoreId: "bc1f3d1f-5dec-44c8-a317-4e5beeac85ed",
    label: "13, Wood Street, Ward No.-63",
  },
  {
    fileStoreId: "7fe7e156-3bd6-450b-b623-e5828a830d16",
    label: "13, Wood Street, Ward No.-63",
  },
  {
    fileStoreId: "5d914cd5-da3f-4abc-95b4-452b48346ae0",
    label: "13/1, Shibnarain Das Lane, Ward No.-38",
  },
  {
    fileStoreId: "b8941409-2532-4007-9016-494697f4a1a8",
    label: "13A, Shikdarbagan Street, Ward No.-11",
  },
  {
    fileStoreId: "2880aabb-47ea-4c04-8ab8-49754c2561c1",
    label: "14, N S Road, Wrad No.-45",
  },
  {
    fileStoreId: "bacce24b-4b3b-423f-862e-084d025f0910",
    label: "14, Netaji Subhas Road, Ward No.-45",
  },
  {
    fileStoreId: "3bc1315b-67c9-4667-bb30-87524d84e325",
    label: "14, Sarojini Naidu Sarani, Ward No.-63c",
  },
  {
    fileStoreId: "6ec34708-a866-480d-9350-8fc38d53e738",
    label: "17, bal Mukund Mackar Road, Ward No.-415",
  },
  {
    fileStoreId: "e2604e28-4fc6-4a6e-9132-0df8ff8edddc",
    label: "17A, Ratan Sarkar Garden Street, Ward No.-22",
  },
  {
    fileStoreId: "a6b9d762-46e8-4e6b-8be5-8ffa09a7d93d",
    label: "18, Judges Court Road, Ward No.-74",
  },
  {
    fileStoreId: "b78d8b56-c7ba-4dc9-89ae-33c875e5ddaa",
    label: "18A, Park Street, Ward No.-63",
  },
  {
    fileStoreId: "72db327c-297f-4a0e-9f33-2518c20bec31",
    label: "18E, Srigopal Mallick Lane, Ward No.-40",
  },
  {
    fileStoreId: "a6869fa0-2850-4267-9b4f-863bdc29fcc3",
    label: "19, Nellie Sen Gupta Sarani",
  },
  {
    fileStoreId: "263d1eae-807d-495f-9240-6b56758c8863",
    label: "22/1/1A, Sudhir Chatterjee Street, Ward No.-26",
  },
  {
    fileStoreId: "38e74f1b-03ea-4de9-b1c7-c9343340a630",
    label: "23, Nirmal Chunder Street, Ward No.-47",
  },
  {
    fileStoreId: "fbac41e9-f608-4c82-b91d-bbf1f44fcb91",
    label: "24, Ballygunge Circular Road, Ward No.-69",
  },
  {
    fileStoreId: "11ca872b-aabe-4e11-9918-1267f3cd0ddc",
    label: "29C, Bentinck Street, Ward No.-46",
  },
  {
    fileStoreId: "23724da9-d0c0-465e-8ec6-397fe3e890bb",
    label: "31/1A & 31/1B, Nayan Chand Dutt Street, Ward No.-17",
  },
  {
    fileStoreId: "b6cd91a2-2c2a-49ad-bf1b-37d3a221f1af",
    label: "34I, Shyampukur Street, Ward No.-10",
  },
  {
    fileStoreId: "9728f3e3-0c28-4f39-8771-dd11d1b70cb1",
    label: "37, Abhedananda Road, Ward No.-16",
  },
  {
    fileStoreId: "7697b7ca-121f-4271-8ccd-2bd630a67fe1",
    label: "18 Uday Shankar Sarani000147, Pathuriaghat Street, Ward No.-24",
  },
  {
    fileStoreId: "34218a20-3415-4383-a516-d22a4d1062e5",
    label: "49, Netaji Subhas Road, Ward No.-45",
  },
  {
    fileStoreId: "f65e4626-08fb-4838-8aaa-06580c463a14",
    label: "51, Netaji Subhas Road, Ward No.-45",
  },
  {
    fileStoreId: "97a75d22-0761-4fbb-bdeb-ca70d1f37ab1",
    label: "52A, Indian Mirror Street, Ward No.-51",
  },
  {
    fileStoreId: "90ec9649-1cb0-4368-b781-06b0b984623c",
    label: "59A, Park Street, Ward No.-63",
  },
  {
    fileStoreId: "12e2eb59-1b56-459b-b791-c16aa6432377",
    label: "71, 71B & 71C, Paddapukur Road, Ward No.-70",
  },
  {
    fileStoreId: "a5e82bc8-5910-497c-ba35-b2a7d5aa6d52",
    label: "76/1B, Bidhan Sarani, Ward No.-16",
  },
  {
    fileStoreId: "ce43098a-06ad-4125-b74d-4b29049d919d",
    label: "81C, Moulana Abul Kalam Azad Sarani, Ward No.-33",
  },
  {
    fileStoreId: "96d94b11-cd9f-4909-91eb-84b615f5a8ed",
    label: "93/1, Acharya Prafulla Chandra Road, Ward No.-38",
  },
  {
    fileStoreId: "fd4e3335-6a4a-49a3-9d0a-17ad4e126bb6",
    label: "98, Dr. Lal Mohan Bhattacharyya Road, Ward No.-55",
  },
  {
    fileStoreId: "68770fa5-73df-40ca-9cee-a22d28a1bd8f",
    label: "98, Shankar Ghosh Lane, Ward No.-38",
  },
  {
    fileStoreId: "de21a2cb-e390-4b45-95a6-1ab481f92462",
    label: "113, Rash Behari Avenue, Ward No.-85",
  },
  {
    fileStoreId: "c3b7665b-ec59-4a6c-ae05-1995bfd32518",
    label: "170, Acharyya Jagadish Bose Road, Ward No.-60",
  },
  {
    fileStoreId: "75d144ea-a034-4c00-99e7-1cc511e41d99",
    label: "294/2/1, Acharya Prafulla chandra Road, Ward No.-28",
  },
  {
    fileStoreId: "0268d090-5971-439e-8223-660f01c25a30",
    label: "General decision taken in HCC meeting dated 29.08.2019",
  },
  {
    fileStoreId: "adcb74f7-9ac4-4a97-9f36-ddf9277aaeab",
    label: "Sri Sri Gopi Nath Jew Thakur Temple at 5, Ratan Babu Road",
  },
  {
    fileStoreId: "53e4af44-0575-4dda-8398-1e08004b9578",
    label: "SS Hogg Market B & NB Block",
  },
  {
    fileStoreId: "8a0f993b-4945-48b4-82d2-e716b1c91091",
    label: "SS Hogg Market Improvement of Roof",
  },
  {
    fileStoreId: "e7b0b86b-34f5-47dd-8028-89838b749f56",
    label: "155A 1 AJC Bose Road0001SS Hogg Market Misc 152",
  },
  {
    fileStoreId: "e314eced-9988-4083-979a-98518e3c5e6a",
    label: "SS Hogg Market MS Rolling Shutter Stall No. 201 E(N)-192",
  },
  {
    fileStoreId: "ecb723bb-0d0d-47a0-a347-0ed11041810a",
    label: "SS Hogg Market Rolling Shutter",
  },
  {
    fileStoreId: "6d8e4736-1198-40e7-aa38-29b9e60b4c71",
    label: "SS Hogg Market Structural Improvement",
  },
  {
    fileStoreId: "d256e1d5-9507-4b24-96b1-35c25ebd63ff",
    label: "SS Hogg Market WR(O) Block",
  },
  {
    fileStoreId: "076b8cdf-1499-4473-9d0c-ca6e2e83bf6b",
    label: "Statesman House 4, Chowringhee Square, Ward No.-46",
  },
  {
    fileStoreId: "e3e5eb45-75f7-492e-a308-622aa5ad9936",
    label: "Temple at Santosh Roy Road near Barisha Clab",
  },
  {
    fileStoreId: "f21d2ee2-80e2-4533-869a-5d787e2f7692",
    label: "2/1, Ho Chi Minh Sarani, Ward No.-63",
  },
  {
    fileStoreId: "e845c45a-6b8b-43cb-b411-d3f723c1b425",
    label: "10, Saheed Nityananda Saha Sarani, Ward No.-45",
  },
  {
    fileStoreId: "cc0afb0b-2d91-4cc7-84de-36f26333de9d",
    label: "12, Park Street, Ward No.-63",
  },
  {
    fileStoreId: "07822465-69f1-46cb-bdc3-5f33ece1d1e2",
    label: "15/1, Strand Road,Ward No.-45",
  },
  {
    fileStoreId: "41c69565-a8f9-4fc1-8a65-39771efe80c2",
    label: "23, Nirmal Chunder Street, Ward No.-47",
  },
  {
    fileStoreId: "2d0af5b6-3267-4c6d-aa49-558063c0f839",
    label: "29, Netaji Subhas Road, Ward No.-45",
  },
  {
    fileStoreId: "a44b4cfd-eca5-472a-822b-1f7ea94eb215",
    label: "30, Park Street, Ward No.-63",
  },
  {
    fileStoreId: "744aab72-aad8-41d2-a0d8-4aaa4abfd190",
    label: "32A, Elliot Road, Ward No.-61",
  },
  {
    fileStoreId: "1e572576-67d2-4178-b5d5-be9cf5f2676c",
    label: "40A, Kashi Mitter Ghat Street, Ward No.-008",
  },
  {
    fileStoreId: "5326c26c-4a79-40ce-8573-c5d269d21d12",
    label: "Declaration of 62/4A & 62/4B, Beadon Street, Ward No.-16",
  },
  {
    fileStoreId: "0e60ae3c-aa2f-45c3-8d3c-fef72e837fe6",
    label: "138/2, Bidhan Sarani, Ward No.-10",
  },
  {
    fileStoreId: "8862bda6-5850-4213-87c7-4acf1a96de0a",
    label: "234/4, Acharya Jagadish Bose Road, Ward No.-70",
  },
  {
    fileStoreId: "52b98fbe-bfe7-48e2-926c-058c86bb273a",
    label: "243/1, Acharyya Prafulla Chandra Road, Ward No.-015",
  },
  {
    fileStoreId: "23afffa0-4773-4a64-a433-577cacd31189",
    label: "SS Hogg Market CVF Block",
  },
  {
    fileStoreId: "24843c82-37a5-42a0-a60d-a149c56084d6",
    label: "SS Hogg Market CVF Block Roof Drainage",
  },
  {
    fileStoreId: "73fe376b-4ec9-4268-aae9-0a224abf74d2",
    label: "SS Hogg Market E(N)-164 Stall No",
  },
  {
    fileStoreId: "36f47b9e-463c-45d9-9dbe-8579569690d8",
    label: "SS Hogg market Food Cell",
  },
  {
    fileStoreId: "a37c440b-444a-468a-944d-f4713664caf1",
    label: "SS Hogg Market G Block",
  },
  {
    fileStoreId: "362e2b6d-ba20-429e-ad11-ca2e9da2b166",
    label: "SS Hogg Market Hudco Building",
  },
  {
    fileStoreId: "af4fb8e6-4339-4398-b2ca-6fed5c58fa97",
    label: "SS Hogg Market NB Block Staff Quarter",
  },
  {
    fileStoreId: "da495e90-8313-4a56-99a9-a86b6a2f357b",
    label: "SS Hogg Market New Complex",
  },
  {
    fileStoreId: "a79273d4-06fc-45cb-a8e7-1fe82c90a845",
    label: "SS Hogg Market Old Complex",
  },
  {
    fileStoreId: "ec576676-5b4c-4ac9-9237-ed3ad9d68b5b",
    label: "SS Hogg Market Renovation of wooden shelves",
  },
  {
    fileStoreId: "eeaa3ed0-82d7-42eb-864b-b5e748b190d5",
    label: "SS Hogg Market Repairing of Main Gate",
  },
  {
    fileStoreId: "c2381a46-d6b0-4284-8180-80d335879a1f",
    label: "SS Hogg Market repairing",
  },
  {
    fileStoreId: "7d46578c-21e6-4d94-9fc4-d48cc10d1f35",
    label: "SS Hogg Market Rolling Shutter",
  },
  {
    fileStoreId: "d10291ed-2e9b-4430-bb68-a1b803061a5d",
    label: "1A,1B./Belvedere road",
  },
  {
    fileStoreId: "86bd89bc-4131-4ec3-ad38-c689f406dc84",
    label: "2,Ballygunge Park",
  },
  {
    fileStoreId: "104d9bf2-546d-468d-804e-4c6a1d9b5fc7",
    label: "3,Lovelock Place,Ward-069",
  },
  {
    fileStoreId: "496515ae-41af-441a-bd32-15c13b0e508c",
    label: "4,Sunny Park",
  },
  {
    fileStoreId: "035b5b90-12c6-40c0-9d6d-e45c1523a6e9",
    label: "4A,Chouringhee Place",
  },
  {
    fileStoreId: "e5633dfc-2de9-4e44-ace1-8b34cac7967d",
    label: "6J,Bishop Lefroy Road,Ward-70",
  },
  {
    fileStoreId: "669e14b3-6227-4e83-8417-3c647f1fb1b5",
    label: "7,sir William Jones Sarani,Ward-063",
  },
  {
    fileStoreId: "40be0f1f-e245-4fa1-8dad-8c42a8b432dd",
    label: "7A&7B,Pratap Chatterjee Lane",
  },
  {
    fileStoreId: "68b3578a-6935-43bc-9912-76480167bfdf",
    label: "8,Baishnab Sett Street",
  },
  {
    fileStoreId: "28ebcdb1-4158-4acb-adaf-7babcbc0f21e",
    label: "9,Circus Avenue",
  },
  {
    fileStoreId: "c832e678-b3c4-4de2-89d5-d041cb4c10b4",
    label: "19,Nellie Sengupta Sarani",
  },
  {
    fileStoreId: "3106d73b-9273-466b-aeff-37bf4a269fb7",
    label: "21,Dr.Suresh Sarkar Road",
  },
  {
    fileStoreId: "daa1cc37-c1e9-42f6-840c-003298a78dca",
    label: "26,Strand Road,Ward-045",
  },
  {
    fileStoreId: "4cf0994a-7da0-4a01-aa70-b2c2636b70a5",
    label: "26A,Khudiram Bose Sarani",
  },
  {
    fileStoreId: "0f1a665f-9889-47ba-a6cb-f1b24578f210",
    label: "30A,Ratan Babu Road",
  },
  {
    fileStoreId: "6caf0740-a1ca-4038-b9e2-77e47fdd9b94",
    label: "45A,Hari Ghosh Street,Ward-017",
  },
  {
    fileStoreId: "edba5ebb-f219-4d92-8134-36a6382aebb3",
    label: "67,Lenin sarani,Ward-51",
  },
  {
    fileStoreId: "5e735f04-d937-4eea-ad31-88585993f1c5",
    label: "80A,Bechu Chatterjee Street",
  },
  {
    fileStoreId: "d32f18d0-d050-4626-b4a5-a563e6f24f78",
    label: "93,Sri Aurobinda Sarani",
  },
  {
    fileStoreId: "f8f117de-0cb8-45ed-9b15-0c3ffe199085",
    label: "118,Raja Ram Mohan Roy Sarani",
  },
  {
    fileStoreId: "f21b8e3a-71e8-46bb-8566-31bfe2d71069",
    label: "224,A.J.C. Bose Road",
  },
  {
    fileStoreId: "801766dd-a057-4de1-954e-d011212a27c6",
    label: "external painting metropolitan bldg. and esplanade mansion",
  },
  {
    fileStoreId: "a5248932-61ae-4255-bfb8-7749073c4fe3",
    label:
      "General discussion on Heritage Buildings at mpl.chambers on 28.07.2021",
  },
  {
    fileStoreId: "708d6c51-9b2f-4cc5-8e25-6f991f0ad73e",
    label: "P-34,Garden Reach Road,Ward-135",
  },
  {
    fileStoreId: "fa4b00ab-cfaf-4b9f-a150-a1fa8832e8ff",
    label: "RENOVATION STALL NO.152(MISC_II_A(p)) SS HOGGMARKET-0001",
  },
  {
    fileStoreId: "60eac73f-3a28-4aaf-b3fe-e6ed34b1881e",
    label: "341 SHYAMPUKUR STREET WD-01",
  },
  {
    fileStoreId: "1208747a-0fdc-4094-9a26-b2cf153e3234",
    label: "22 1 1A SUDHIR CHATERJEE STREET WD-026",
  },
  {
    fileStoreId: "a38db2ba-dca4-4b19-bd2e-993dee19a176",
    label: "18A PARK STREET WD-063",
  },
  {
    fileStoreId: "f6a05925-961f-477a-b12d-6750bbfa0960",
    label: "17A RATAN SARKAR GARDEN STREET WD-022",
  },
  {
    fileStoreId: "2dc52e8c-6413-49eb-a29e-e5a89844c72c",
    label: "14 NETAJI SUBHAS ROAD WD-045",
  },
  {
    fileStoreId: "5c264cef-c085-4a24-95db-4bb8beca7c21",
    label: "3 LOVELOCK PLACE WD-069",
  },
  {
    fileStoreId: "0ff01319-5525-4ea2-88cd-d60ef8351643",
    label: "1 RAJENDRA NATH MUKHERJEE ROAD WD-046",
  },
  {
    fileStoreId: "e6d49f73-fbd8-48db-a4d9-3340839d3da2",
    label: "1 CLIVE BUILDINGS WD-045",
  },
  {
    fileStoreId: "70ff20a2-2627-4705-bc7d-0dc1f4052529",
    label: "ROLLING SHUTTER STAFF QUARTER SS HOGG MAR-01",
  },
  {
    fileStoreId: "86259d6d-60b3-46bc-8449-c3ef052c33bd",
    label: "IMPROVEMENT WR(O) BLOCK SS HOGG MARKET-001",
  },
  {
    fileStoreId: "",
    label: "IMPROVEMENT OF ROOF BLOCK B, NB SS HOGG MARKET-01",
  },
  {
    fileStoreId: "f94b1a78-c12b-4cc4-8471-e3a79ef9a4df",
    label: "13A SIKDARBAGAN STREET_WD-011",
  },
  {
    fileStoreId: "bea1f1db-08fc-4868-bec1-f2a08f14181d",
    label: "18 JUDGES COURT ROAD-74",
  },
  {
    fileStoreId: "b9425d21-35f7-4901-b1fe-4cb6ad40a6ed",
    label: "23 NIRMAL CHUNDER STREET WARD-047",
  },
  {
    fileStoreId: "e9a6a07d-f456-429f-8f3f-840030cb8eac",
    label: "1 Hogg Street,CVF Block0001",
  },
  {
    fileStoreId: "7439059c-7fea-4e3b-ba26-69fa4021bfc8",
    label: "1 Rajendra Nath Mukherjee Rd0001",
  },
  {
    fileStoreId: "5a9cb1a2-ed51-431c-a61d-97fe5fbdd78c",
    label: "1 1D Prem Chand Boral St.0001",
  },
  {
    fileStoreId: "fef06726-f245-49c3-8f81-9abab130e0b6",
    label: "4 Chowringhee Square0001",
  },
  {
    fileStoreId: "d36d043e-15ce-4f5f-aabf-3a045717cb80",
    label: "6 Ashutosh De Lane0001",
  },
  {
    fileStoreId: "a61b8dd1-e8e4-4af6-ab70-b908205c1ef0",
    label: "6 1 Nellie Sengupta Sarani0001",
  },
  {
    fileStoreId: "7523de5d-0839-477a-8194-f10012b56f69",
    label: "7 Harish Ch Paul Lane0001",
  },
  {
    fileStoreId: "8f03c9bf-5137-4e11-ad89-57197abc6932",
    label: "8 Baishnab Sett Street0001",
  },
  {
    fileStoreId: "7144d6c9-dc31-455e-b9e5-a7fc8a08e310",
    label: "8 Raja Gurudas St.0001",
  },
  {
    fileStoreId: "b4df8d24-b18a-4c18-9e4b-d81e18fae7cb",
    label: "8 Red Cross Place0001",
  },
  {
    fileStoreId: "c6069619-0c18-40bf-8f4f-2ef8ee3c78fb",
    label: "9 2G Khelat Ghose Lane0001",
  },
  {
    fileStoreId: "13abb9ad-84bf-4c53-9e0f-04f77fd18394",
    label: "9B Raja Kali Krishna Lane0001",
  },
  {
    fileStoreId: "e080272f-d15a-4849-be28-f3d63d60b299",
    label: "10 Ramesh Dutt Street0001",
  },
  {
    fileStoreId: "ba47063d-4f2f-4ebc-aa05-9dd21d75a382",
    label: "12 Kailash Bose Street0001",
  },
  {
    fileStoreId: "3a9f52a5-dfb6-42fd-ab90-f47d1b200170",
    label: "13 2B, Balaram Ghosh St.0001",
  },
  {
    fileStoreId: "b42eacea-0329-4d4b-ab90-14123319149b",
    label: "14, N. S. Road0001",
  },
  {
    fileStoreId: "cca180b3-452b-4457-ac6a-e5ab93559ec7",
    label: "16A Kali Prosad Chakraborty St.0001",
  },
  {
    fileStoreId: "acfb365c-8e86-47ce-bb5b-9037e5ae5186",
    label: "17 Bal Mukund Mackar Rd 11.07.190001",
  },
  {
    fileStoreId: "4e166428-5387-4022-915c-55a82c800ca3",
    label: "17 Bal Mukund Mackar Rd 29.08.19",
  },
  {
    fileStoreId: "2108b6fe-1f21-4101-b18b-4655609dc416",
    label: "17 Bal Mukund Mackar Road 10.01.190001",
  },
  {
    fileStoreId: "7445a0dc-cefb-46e0-8add-af6dab6c20a7",
    label: "17 Ratan Sarkar Garden St.0001",
  },
  {
    fileStoreId: "964bb629-7f38-41a8-995d-2d1e1a2e3084",
    label: "18 Uday Shankar Sarani0001",
  },
  {
    fileStoreId: "31e40212-b9d4-449f-ad76-5989cf1b43f2",
    label: "18 39 Jamini Roy Sarani0001",
  },
  {
    fileStoreId: "12fc2f9c-105e-4f9d-9e6b-9f78f64f6123",
    label: "18A Srigopal Mallick Lane0001",
  },
  {
    fileStoreId: "8a6a51e0-085f-43ef-8b04-6f403cf0e16f",
    label: "19 Nellie Sen Gupta Sarani0001",
  },
  {
    fileStoreId: "d270c2f0-834d-48d3-abc4-37c05aec0fcc",
    label: "20A Karl Marx Sarani0001",
  },
  {
    fileStoreId: "7ca7ccf3-0f49-48ce-9446-e395dbab5a88",
    label: "24 1 Maharshi Debendra Rd0001",
  },
  {
    fileStoreId: "34630dad-5893-4cf9-9f55-eee7347820fe",
    label: "25B Vivekananda Road0001",
  },
  {
    fileStoreId: "ad1c57e1-6b51-49e2-94d3-f029f10728a1",
    label: "34 Surya Sen Street0001",
  },
  {
    fileStoreId: "9c9600c3-c8ba-4622-821e-a7bb9ccf88a8",
    label: "34F Shyampukur St.0001",
  },
  {
    fileStoreId: "cbe63ed7-0f4d-4b86-8765-cd57a53c889d",
    label: "45A Hari Ghosh St.0001",
  },
  {
    fileStoreId: "0d9f3fa7-b130-4955-902d-e7bdf54908ef",
    label: "47 N. S. RD0001",
  },
  {
    fileStoreId: "aa3d5635-605a-427a-b488-54e54eac9a7c",
    label: "53B Diamond Road0001",
  },
  {
    fileStoreId: "c8bc7bbe-3c1d-4ebc-8c26-3ceb1f1a570d",
    label: "55 N. S. RD0001",
  },
  {
    fileStoreId: "5383691b-541e-4fe5-9267-56a61f744777",
    label: "60 14 Gouribari Lane0001",
  },
  {
    fileStoreId: "50181840-d604-4657-a44c-cbf4e24a345f",
    label: "81C Moulana Abul Kalam Azad Sarani0002",
  },
  {
    fileStoreId: "ff77f27d-0a62-47e8-ae97-d0fab5ea4e75",
    label: "120 Deshpran Shasmal Rd 11.07.190001",
  },
  {
    fileStoreId: "528bcfa9-bedb-4d07-93ab-08eb65f7c7f7",
    label: "120 Deshpran Shasmal Rd 20.09.19",
  },
  {
    fileStoreId: "b9245f75-1475-4e52-8383-40dd8735e060",
    label: "120 2 APC Road0001",
  },
  {
    fileStoreId: "593c960a-91c6-452b-b63f-44a22a94e1bb",
    label: "155A 1 AJC Bose Road0001",
  },
  {
    fileStoreId: "c13a3d6a-5f01-4188-a740-ad9f534dc7a2",
    label: "170 2D AJC Bose Road0001",
  },
  {
    fileStoreId: "6a143cc6-fd71-4354-b93a-9806d2274e59",
    label: "211 Bidhan Sarani0001",
  },
  {
    fileStoreId: "380ef18d-bd66-429f-91bd-4fab47a7aad6",
    label: "Damaged Terrace above F Block-Hogg Market0001",
  },
  {
    fileStoreId: "de626e5b-ca1a-43cc-86af-d3437674aca9",
    label: "Desicions taken as a follow up of HCC resolutions0001",
  },
  {
    fileStoreId: "dedf9e66-2512-461f-8efe-a26a146d321a",
    label: "Heritage Ghat at Adi Ganga00010001",
  },
  {
    fileStoreId: "529407bc-bf99-4517-84d5-3beaf39e2b0f",
    label: "Nimtola Burning Ghat Wooden Pyres0001",
  },
  {
    fileStoreId: "b71c7687-6adf-411d-8ad2-10df61cf97bf",
    label: "P-431 Hemanta Mukhopadhyay sarani0001",
  },
];

const Heritage_Proceedings_of_HCC = () => (
  <TableStructure
    title="Proceedings of HCC"
    heading={"Name"}
    list={List}
    columnNo={1}
    leftMenuList={EnvironmentHeritageLeftMenuList}
    longMenuList={true}
  />
);

export default Heritage_Proceedings_of_HCC;
